<div *ngIf="pagination" [ngStyle]="{'pointer-events': pages.length > 1 ? 'auto' : 'none' }"
     class="pagination">
    <ul>
        <li (click)="prev()"
            [ngStyle]="{opacity: pagination.current_page !== 1 ? 1 : 0,
						'pointer-events': pagination.current_page !== 1 ? 'auto' : 'none' }"
            class="left" data-action="previousPage">
            <a><i [ngStyle]="{'color': pagination.current_page !== 1 ? '#174882' : 'lightgray'}"
                  class="icon-left-3"></i></a>
        </li>
        <ng-container *ngFor="let item of pages">
            <li [class.active]="item === pagination.current_page" class="link">
                <a (click)="setPage(item)" [attr.data-number-page]="item" data-action="setPage">{{ item }}</a>
            </li>
        </ng-container>
        <li (click)="next()"
            [ngStyle]="{'pointer-events': pagination.current_page !== pages.length ? 'auto' : 'none' }"
            class="right"
            data-action="nextPage">
            <a><i [ngStyle]="{'color': pagination.current_page !== pages.length ? '#174882' : 'lightgray'}"
                  class="icon-right-3"></i></a>
        </li>
    </ul>
</div>
